import { IconComponent } from 'types/icon';

const TooltipTick: IconComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
    <path d="M10,0 L3,10 L10,20" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default TooltipTick;
